"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeadMetaWrapper = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const web_head_meta_1 = require("@snapchat/web-head-meta");
const webConfigContext_1 = require("./webConfigContext");
/**
 * Enhances <HeadMeta> by allowing dynamic prop computation based on web configs.
 */
function HeadMetaWrapper({ headMetaProps, mapHeadMetaProps, }) {
    const configs = webConfigContext_1.webConfigContext.useConfigs();
    const props = mapHeadMetaProps ? mapHeadMetaProps(headMetaProps, configs ?? []) : headMetaProps;
    return (0, jsx_runtime_1.jsx)(web_head_meta_1.HeadMeta, { ...props });
}
exports.HeadMetaWrapper = HeadMetaWrapper;
//# sourceMappingURL=HeadMetaWrapper.js.map